<div class="px-6 py-2 md:pt-4 md:pb-0" [ngClass]="{'mb-16 md:mb-0': !notices || notices && !notices.length}">
    <div *ngIf="notices && notices.length" class="relative shrink-0 bg-carousel rounded-lg overflow-hidden"
         [style.height]="'30vh'" [style.min-height]="'13rem'">

        <div class="absolute left-1 md:left-4 flex items-center justify-center h-full z-90">
            <button *ngIf="index > 0" (click)="previous()" mat-icon-button class="bg-white shadow-default">
                <mat-icon class="icon-size-5 text-white" [svgIcon]="'awesome_solid:angle-left'"></mat-icon>
            </button>
        </div>

        <div class="absolute right-1 md:right-4 flex items-center justify-center h-full z-90">
            <button *ngIf="index < notices.length - 1" (click)="next()" mat-icon-button class="bg-white shadow-default">
                <mat-icon class="icon-size-5 text-white" [svgIcon]="'awesome_solid:angle-right'"></mat-icon>
            </button>
        </div>

        <div class="flex flex-wrap h-full w-full z-50">
            <div class="flex items-center w-full h-full">

                <!-- Conteúdo desktop -->
                <div class="hidden md:flex flex-col w-6/12 h-full pl-18 py-4 pr-6 lg:pr-10 xl:pr-12">
                    <div class="shrink-0 self-start w-fit border border-white rounded-full bg-white px-4 py-1 text-blue-800 uppercase">
                        Mural de avisos
                    </div>

                    <div class="shrink-0 w-full text-lg mt-2 text-white font-semibold line-clamp-2">
                        {{ notices[index].title }}
                    </div>

                    <div class="flex-1 w-full mt-2 text-md text-white" [fitLines]="notices[index].message">{{ preview(notices[index].message) }}</div>

                    <div class="shrink-0 flex items-center justify-between w-full mt-auto pt-2">
                        <span class="text-sm text-white font-light">{{ notices[index].date | date: 'dd/MM/yyyy' }}</span>
                        <button (click)="redirect()" class="text-white text-sm font-semibold text-center px-4 py-1">
                            Ver mais
                        </button>
                    </div>
                </div>

                <div class="relative w-full md:w-6/12 h-full overflow-hidden bg-carousel">
                    <div class="absolute left-0 md:left-1/4 top-0 w-full md:w-3/4 h-full overflow-hidden image-skeleton"
                         [class.loading]="!imageLoaded">
                        <img
                            class="block w-full h-full object-cover"
                            [src]="notices[index].coverImageUrl || 'assets/images/notice-board/notice-board-cover.jpg'"
                            (load)="imageLoaded = true"
                            (error)="imageLoaded = true"
                            (loadstart)="imageLoaded = false"
                        >
                    </div>

                    <img
                        src="assets/images/notice-board/carousel-arcs.svg"
                        class="hidden md:block absolute top-0 z-10 pointer-events-none carousel-arcs"
                        aria-hidden="true"
                    />
                </div>

                <!-- Conteúdo mobile -->
                <div class=" md:w-6/12 md:pr-2 md:hidden textMobile absolute ">
                    <div class="flex flex-col min-h-0 py-2 px-2 z-50">
                        <div class="shrink-0 w-full text-white font-light  text-center z-100"><p class="">Mural de avisos</p></div>
                        <div class="shrink-0 w-full text-xl mt-1 text-white font-semibold uppercase  text-center line-clamp-2">{{notices[index].title}}</div>
                        <div class="shrink-0 w-full text-sm text-white font-semibold uppercase  text-center ">{{notices[index].date | date: 'dd/MM/yyyy'}}</div>
                        <div class="w-full mt-1 text-sm text-white font-semibold text-center" [fitLines]="notices[index].message">{{ preview(notices[index].message) }}</div>
                        <div (click)="redirect()" class="shrink-0 w-full mt-1 ion-text-center text-white font-bold cursor-pointer buttonMobile">
                            <button class="bg-default font-bold text-white text-center rounded-full py-2 px-6 shadow-default" mat-flat-button [color]="'primary'">
                                Ver mais
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div *ngIf="notices?.length > 1"
            class="absolute bottom-3 left-0 right-0 z-50 flex justify-center items-center gap-3">
            <button
                *ngFor="let notice of notices; let i = index"
                type="button"
                (click)="goTo(i)"
                [ngClass]="index === i ? 'bg-white' : 'bg-transparent'"
                [style.border]="index === i ? '1px solid white' : '1px solid white'"
                class="w-2 h-2 rounded-full box-border transition-all duration-300"
                [attr.aria-label]="'Ir para aviso ' + (i + 1)"
                [attr.aria-current]="index === i ? 'true' : null"
            ></button>
        </div>

    </div>
    <div *ngIf="notices?.length <= 0" class="relative mt-16 md:mt-0 md:px-6">
        <div class=""></div>
    </div>
</div>
